import { inject, Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { FavIcon } from '../../../shared/models/enums/favicon.enum'
import { HostEnvironment, HostEnvironmentEnum } from '../../../shared/models/host-environment'
import { CoreUtils } from '../../utils/core.utils'

@Injectable({ providedIn: 'root' })
export class PortailChantierHostEnvironmentService extends HostEnvironment {
    id = HostEnvironmentEnum.portailChantier
    url = 'portailchantier'

    private title = inject(Title)
    setFavicon(): void {
        CoreUtils.setFaviconElement(FavIcon.iconePortailChantier)
    }

    setTitle(): void {
        this.title.setTitle('Portail Chantier')
    }
}
